import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "count"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasSourceTarget || !this.hasCountTarget) return

    const max = this.sourceTarget.getAttribute("maxlength") || this.sourceTarget.dataset.max || ""
    const length = this.sourceTarget.value.length
    this.countTarget.textContent = max ? `${length} / ${max}` : `${length}`
  }
}
